(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlComboKeyValueMultiple', [])
        .directive('dynamicComboKeyValueMultiple', ['adminMetadataService', 'errorsExtend', '$filter',
            function (adminMetadataService, errors, $filter) {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-combo-key-value-multiple/custom-control-combo-key-value-multiple-template.html',
                controller: [
                    '$scope', function ($scope) {
                        $scope.value = '';
                        $scope.description = '';
                        $scope.hasInactiveItems = false;


                        $scope.checkIfHasInactiveItems = function () {
                            $scope.hasInactiveItems = false;

                            this.data.metadataValue.forEach(function (metadataValue) {
                                var item = $filter('filter')($scope.data.metadataOptions, { value: metadataValue, active: false }, true);
                                if (item.length > 0) {
                                    $scope.hasInactiveItems = true;
                                }
                            });
                        };

                        if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                            $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                        }

                        if ($scope.hideinactive) {
                            function getActives(option) {
                                return option.active === undefined ? true : option.active;
                            };

                            var activeItems = $scope.data.metadataOptions.filter(getActives);
                            $scope.data.metadataOptions = activeItems;
                        }


                        if ($scope.data.metadataValue) {
                            function isOnMetadataValue(option) {
                                return $scope.data.metadataValue.indexOf(option.value) > -1;
                            }

                            $scope.data.metadataValue = Array.isArray($scope.data.metadataValue) ? $scope.data.metadataValue : JSON.parse($scope.data.metadataValue);

                            $scope.checkIfHasInactiveItems();
                        }

                        $scope.selectMetadata = function (metadata) {
                            if (!Array.isArray(this.data.metadataValue)) {
                                this.data.metadataValue = [];
                            }

                            if (!$scope.hasInactiveItems) {
                                var item = $filter('filter')($scope.data.metadataOptions, { value: metadata.value, active: false }, true);
                                if (item.length > 0) {
                                    $scope.hasInactiveItems = true;
                                }
                            }
                        };

                        $scope.removeMetadata = function (metadata) {
                            var index = this.data.metadataValue.indexOf(metadata.value);
                            if (index > -1) {
                                this.data.metadataValue.splice(index, 1);
                            }
                            $scope.checkIfHasInactiveItems();
                        };

                        $scope.save = function () {
                            if (this.$parent.value) {
                                var item = {
                                    metadataId: this.$parent.data.metadataId,
                                    key: this.$parent.value,
                                    description: this.$parent.description
                                };
                                adminMetadataService.addMetadataValues(item).then(function (result) {
                                    $scope.addToOptions(result);
                                }, function (error) {
                                    errors.showError(error);
                                });
                            }
                            else {
                                errors.showError('VerifyFormData');
                            }
                        };

                        $scope.cancel = function () {
                            this.value = '';
                            this.description = '';
                        }

                        $scope.addToOptions = function (result) {
                            this.data.metadataOptions.push({ value: result.key, description: result.description });
                            this.value = '';
                            this.description = '';
                            $('#addItemModal' + this.data.metadataId).modal('hide');
                        };
                    }]
            };
        }]);

    angular.module('CustomControlComboKeyValueMultiple')
        .directive('dynamicFilterComboKeyValueMultiple', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-combo-key-value-multiple/custom-control-filter-combo-key-value-multiple-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {

                        $scope.data.tempMetadataValue = [];

                        if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                            $scope.data.metadataSearchTypeFrom = 'All';
                        }

                        if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                            $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                        }

                        if ($scope.data.metadataValueFrom) {
                            function isOnMetadataValue(option) {
                                return $scope.data.metadataValueFrom.indexOf(option.value) > -1;
                            }

                            var selectedOptions = $scope.data.metadataOptions.filter(isOnMetadataValue);

                            selectedOptions.forEach(function (item, index) {
                                $scope.data.tempMetadataValue.push(item);
                            });
                        }

                        $scope.selectMetadata = function (metadata) {
                            if (!Array.isArray(this.data.metadataValueFrom)) {
                                this.data.metadataValueFrom = [];
                            }

                            this.data.metadataValueFrom.push(metadata.value);
                        };

                        $scope.removeMetadata = function (metadata) {
                            var index = this.data.metadataValueFrom.indexOf(metadata.value);
                            if (index > -1) {
                                this.data.metadataValueFrom.splice(index, 1);
                            }
                        };

                        $scope.onNullChanged = function (data) {
                            if (this.data.nullValue) {
                                this.data.metadataValueFrom = [];
                                this.data.tempMetadataValue = [];
                            }
                        };
                    }
                ],
                link: function (scope, iElement, iAttrs, formCtrl) {
                    scope.filterNullValue = iAttrs.filternullvalue;
                }
            };
        }]);
})();